import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'INVIT_CLIENT',
  title: 'Comment puis-je donner accès à mon dossier à mes clients ?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Tout d’abord, votre client n’a pas besoin d’être adhérent sur la plateforme pour avoir accès à la plateforme. Pour lui donner accès à votre dossier, il suffit de le rechercher et de l’inviter en suivant le schéma ci-dessous.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Rendez-vous sur l’onglet « Clients »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_CLIENT/FR_INVIT_CLIENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez sur le bouton bleu « Rechercher un client » situé en haut à droite de votre écran.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_CLIENT/FR_INVIT_CLIENT_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Recherchez « votre client » dans la barre de recherche.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_CLIENT/FR_INVIT_CLIENT_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Votre client apparait dans la liste ? Un simple clic dessus l’ajoute à votre liste de client.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_CLIENT/FR_INVIT_CLIENT_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Votre client n’apparait pas dans la liste ? Cliquez sur « Inviter l’organisation « Nom de l’organisation » à rejoindre le réseau ».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_CLIENT/FR_INVIT_CLIENT_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Renseignez ensuite les informations demandées.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_CLIENT/FR_INVIT_CLIENT_6.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '7.',
    value: 'Validez !'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_INVIT_CLIENT/FR_INVIT_CLIENT_7.png`
  }]
};
